import numeral from "numeral";
import { formatMoney } from "./stringUtils.js";
const formatRewardAmount = (rewardAmount, includeDecimal = false) => {
  if ((rewardAmount == null ? void 0 : rewardAmount.rewardAmountType) === "percent") {
    return numeral((rewardAmount == null ? void 0 : rewardAmount.rewardPercent) / 100).format(`0,0%`);
  }
  return formatMoney(rewardAmount == null ? void 0 : rewardAmount.rewardAmount, "$", includeDecimal);
};
const getBrandIds = (brandEntity) => {
  if ((brandEntity == null ? void 0 : brandEntity.brandIds) && Array.isArray(brandEntity.brandIds) && brandEntity.brandIds.length > 0) {
    return brandEntity.brandIds;
  }
  if ((brandEntity == null ? void 0 : brandEntity.brandId) != null) {
    return [brandEntity.brandId];
  }
  return void 0;
};
export {
  formatRewardAmount,
  getBrandIds
};
//# sourceMappingURL=brandUtils.js.map
